export default "__VITE_ASSET__BGA7cl32__"